import { render, staticRenderFns } from "./SplitTransloadAndDeliver.vue?vue&type=template&id=8554bc64"
import script from "./SplitTransloadAndDeliver.vue?vue&type=script&lang=js"
export * from "./SplitTransloadAndDeliver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports